export default {
    // "a":   information
    // "e":   error
    // "w":   warning
    // "x":   exception
    /**
     * проверяет тип - является ли он ошибкой
     * @param type - инфо тип, приходит с ответом с сервера
     * @returns {boolean}
     */
    isError(type) {
        return type === "e" || type === "x";
    },
    /**
     * проверяет тип - является ли он предупреждением
     * @param type - инфо тип, приходит с ответом с сервера
     * @returns {boolean}
     */
    isWarning(type) {
        return type === "w";
    },
    /**
     * получить stack из тела ошибки
     * @param error - объект ошибки
     * @returns {*}
     */
    getStackTraceError(error) {
        if (error.stack) {
            return error.stack;
        } else {
            return error;
        }
    },
};
